import React from 'react';

import classNames from 'classnames';

import FormContainer from '../FormContainer';

export default function SettingsContainer({
  form,
  noSubmit,
  isVisible,
  groupSizeOffset = 0,
  tabindex,
  readOnly,
  noBorder,
  isSubmitting,
}) {
  return (
    <div
      className={classNames(
        'p-7 col-span-full sm:col-span-6 xl:col-span-4 bg-white dark:bg-slate-800 mb-10',
        {
          'shadow-lg rounded-sm border border-slate-200 dark:border-slate-700':
            !noBorder,
        }
      )}
    >
      <FormContainer
        form={form}
        noSubmit={noSubmit}
        isVisible={isVisible}
        groupSizeOffset={groupSizeOffset}
        tabindex={tabindex}
        readOnly={readOnly}
        noBorder={noBorder}
        gridStyle="flex flex-col gap-y-8"
        isSettingsForm
        isSubmitting={isSubmitting}
        noBillComId
        submitButtonStyle="!bg-blue-500 !hover:bg-blue-700 text-white font-bold !py-2 !px-4 rounded !w-full !max-w-full"
        fullWidthSubmitButton
      />
    </div>
  );
}
